(function () {
  var STORAGE_KEY = 'rochemara_recently_viewed';

  function getStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  document.querySelectorAll('.recently-viewed').forEach(function (section) {
    var currentIdRaw = section.dataset.currentProductId;
    var currentId = currentIdRaw ? parseInt(currentIdRaw, 10) : null;
    var maxProducts = parseInt(section.dataset.maxProducts, 10) || 6;

    var list = getStored().filter(function (item) {
      return item && (!currentId || item.id !== currentId);
    });
    if (list.length === 0) return;

    list = list.slice(0, maxProducts);
    var ul = section.querySelector('.recently-viewed__list');
    if (!ul) return;

    list.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'recently-viewed__item';

      var a = document.createElement('a');
      a.href = item.url;
      a.className = 'recently-viewed__link';

      var imgWrap = document.createElement('div');
      imgWrap.className = 'recently-viewed__image-wrapper';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || '';
        img.loading = 'lazy';
        img.width = 300;
        img.height = 300;
        imgWrap.appendChild(img);
      }

      var title = document.createElement('p');
      title.className = 'recently-viewed__title';
      title.textContent = item.title || '';

      var price = document.createElement('p');
      price.className = 'recently-viewed__price';
      price.textContent = item.price || '';

      a.appendChild(imgWrap);
      a.appendChild(title);
      a.appendChild(price);
      li.appendChild(a);
      ul.appendChild(li);
    });

    section.hidden = false;
  });
})();
